<template>
<component :is="button ? 'button': link ? 'a' : 'div'"
           class="common-chip"
           :class="{'common-chip--filled': filled}"
           :type="button ? 'button' : null"
           :href="link ?? null">
  <slot>
    {{ label }}
  </slot>
</component>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: null,
    },
    button: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
